import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  copyLabel: {
    id: 'jira-common.ListProjectForms.Copy',
    defaultMessage: 'Copy to project',
    description: 'Label for a dropdown item, which pops a modal to copy a form between projects.'
  },
  deleteLabel: {
    id: 'jira-common.ListProjectForms.Delete',
    defaultMessage: 'Delete',
    description: 'Text for a modal dialog title when prompting the user to delete a form'
  },
  downloadFlagCompleteTitle: {
    id: 'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle',
    defaultMessage: '“{filename}” downloaded'
  },
  downloadFlagErrorDescription: {
    id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription',
    defaultMessage: 'Refresh the page and try again.'
  },
  downloadFlagErrorTitle: {
    id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle',
    defaultMessage: '“{filename}” not downloaded'
  },
  downloadFlagPercentComplete: {
    id: 'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete',
    defaultMessage: '{percentCount, plural, one {# % complete} other {# % complete}}'
  },
  downloadFlagTitle: {
    id: 'jira-common.ListProjectForms.FormActions.DownloadFlagTitle',
    defaultMessage: 'Downloading “{filename}”'
  },
  edit: {
    id: 'form-system.general.Edit',
    defaultMessage: 'Edit',
    description: 'Text for a button that links to an editor for project forms'
  },
  exportInXlsx: {
    id: 'jira-common.ListProjectForms.FormActions.ExportInXlsx',
    defaultMessage: 'Export in XLSX',
    description: 'Label for a link to export forms into an Excel spreadsheet'
  },
  moreActions: {
    id: 'jira-common.ListProjectForms.FormActions.MoreActions',
    defaultMessage: 'More actions',
    description: 'Label for the dropdown menu that contains additional actions for a form'
  }
});